export default __webpack_public_path__ + "static/media/GestHotelpage.869c9d58.png";